import { buildMockPromise } from "../api/helpers";

export async function postManualRateDoneMock(
  reportUUID: string
): Promise<string> {
  return await buildMockPromise("OK", 1000);
}
